import { SectionHeader } from "@/components/SectionHeader";
import { Reveal } from "@/components/Reveal";
import { FaqAccordion } from "@/components/FaqAccordion";

export const HOME_FAQ = [
  { q: "Combien coûte un ravalement de façade ?", a: "Le prix dépend de la surface, de l'état de la façade et de la finition choisie (peinture, enduit, hydrofuge). Chaque maison est différente : un devis gratuit, établi sur place, vous donne le vrai chiffre pour votre projet." },
  { q: "Faut-il un traitement hydrofuge après un ravalement ?", a: "Ce n'est pas obligatoire, mais fortement recommandé. Il protège la façade de l'humidité, des mousses et de la pollution. Résultat : votre ravalement dure deux fois plus longtemps." },
  { q: "Combien de temps prend un chantier de ravalement ?", a: "Pour une maison individuelle standard, comptez 4 à 10 jours de chantier selon la surface et la météo. On vous donne le planning précis dans le devis." },
  { q: "Le devis est-il vraiment gratuit ?", a: "Oui, entièrement. On vient chez vous, on évalue le chantier, on vous envoie un devis détaillé. Vous êtes libre de le refuser sans aucun frais." },
  { q: "Jusqu'où vous déplacez-vous ?", a: "Zone principale : Dordogne, Lot, sud Limousin, Charente. Au-delà, appelez-nous, on regarde ce qu'on peut faire." },
  { q: "Vous travaillez aussi pour les professionnels ?", a: "Oui, mais 90% de nos chantiers sont chez des particuliers. Pour un devis pro, appelez-nous directement." },
];

export const HomeFaq = () => (
  <section className="py-16 lg:py-28 bg-surface-canvas relative overflow-hidden" data-testid="faq-section">
    {/* Forme decorative discrete - dégradé bleu pâle, purement visuel */}
    <div
      className="absolute -bottom-40 -left-40 w-[460px] h-[460px] rounded-full pointer-events-none"
      style={{ background: "radial-gradient(circle, rgba(74,130,214,0.10) 0%, rgba(30,79,168,0.05) 45%, transparent 70%)" }}
      aria-hidden="true"
    />
    <div className="max-w-[780px] mx-auto px-5 lg:px-6 relative">
      <SectionHeader label="Questions fréquentes" title="Vos questions, nos réponses." />
      <Reveal>
        <FaqAccordion items={HOME_FAQ} testIdPrefix="home-faq" />
      </Reveal>
    </div>
  </section>
);
